import React from 'react';
import createPlotlyComponent from 'react-plotlyjs';
import Plotly from 'plotly.js/dist/plotly-cartesian';
import PropTypes from 'prop-types';



function LineChart({ title, xAxis, yAxis,  xAxisTitle, yAxisTitle}) {
    const PlotlyComponent = createPlotlyComponent(Plotly);
    const data = [
        {
            type: 'scatter',
            x: xAxis,
            y: yAxis,
            marker: {
                color: '#8FDB00'
            }
        }
    ];

    const layout = {
        title,
        xaxis: {
            title: xAxisTitle
        },
        yaxis: {
            title: yAxisTitle
        }
    }

    const config = {
        showLink: false,
        displayModeBar: true,
        displaylogo: false
    }

    return (
        <PlotlyComponent data={data} layout={layout} config={config}/>
    )
}

LineChart.propTypes = {
    title:PropTypes.string,
    xAxisTitle:PropTypes.string,
    yAxisTitle:PropTypes.string,
    xAxis:PropTypes.array,
    yAxis:PropTypes.array
};

export default LineChart;